import { Injectable } from '@angular/core';

import { AiFunctionCallControllerService } from '@rappider/rappider-sdk';
import { fi } from 'date-fns/locale';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RapiderAiService {

  constructor(
    private aiFunctionCallControllerService: AiFunctionCallControllerService
  ) { }

  getAiFeatureFunctions(): Observable<any[] | null | undefined> {

    const filter = {
      where: {
        exposeAsFeature: true
      }
    };

    return this.aiFunctionCallControllerService.find({ filter }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error fetching AI features:', error);
        return of(undefined); // Return undefined on error
      })
    );
  }


  getAiFunctionIdWithName(aiFunctionName: string): Observable<string | null | undefined> {

    const filter = {
      where: {
        name: aiFunctionName
      },
      fields: ['id']
    };

    return this.aiFunctionCallControllerService.find({ filter }).pipe(
      map(response => response ? response[0]?.id : null),
      catchError(error => {
        console.error('Error fetching AI function:', error);
        return of(undefined); // Return undefined on error
      })
    );
  }

}
